// weeklyThemeContent.js — Conteúdo interno teologicamente conferido dos
// 7 dias de cada tema semanal. Usado como sobrescrita quando o endpoint
// /api/integrations/prayer-week da landing está desalinhado com o
// /api/integrations/weekly-theme (bug crítico: título de um tema com
// conteúdo de outro).
//
// Regra: se o `theme_slug` do weekly-theme não bater com o conteúdo dos
// dias do prayer-week, o app usa este conteúdo interno para renderizar.
// Assim que a landing sincronizar, o override desaparece automaticamente
// (detectContentMatch retorna true → landing content wins).

const CURA_DAYS = [
  {
    day: 1,
    title: "Cristo, nossa esperança de cura",
    verse_ref: "Jr 17:14 (ARC)",
    verse_text: "Cura-me, Senhor, e sararei; salva-me, e serei salvo; porque tu és o meu louvor.",
    focus: "A cura começa em Cristo",
    reflection: "Deus é a fonte de toda cura. Cristo curou durante seu ministério terreno e continua sendo nossa esperança hoje. A cura é dom da graça, não conquista humana; recebemos das mãos do Senhor com humildade e fé.",
    prayer_direction: "Clame ao Senhor pela cura que somente Ele pode dar. Apresente diante de Deus a área da sua vida que precisa ser restaurada e entregue nas mãos do Pai.",
    challenge: "Reserve um momento hoje, apresente a Deus uma área da sua vida que precisa de cura e entregue nas mãos Dele.",
  },
  {
    day: 2,
    title: "Cura do coração ferido",
    verse_ref: "Sl 147:3 (ARC)",
    verse_text: "Sara os quebrantados de coração e liga-lhes as feridas.",
    focus: "Deus sara os de coração quebrantado",
    reflection: "A cura emocional é tão real quanto a cura física. Deus conhece cada ferida do coração, cada lágrima escondida, cada dor não dita. Nada escapa ao olhar do Pai que se compadece.",
    prayer_direction: "Apresente a Deus as dores que carrega por dentro. Permita que o Espírito Santo alcance os lugares mais profundos da sua alma e traga o bálsamo de Sua presença.",
    challenge: "Escreva uma dor que ainda carrega e ore sobre ela, entregando ao cuidado de Deus.",
  },
  {
    day: 3,
    title: "O perdão que restaura a alma",
    verse_ref: "Ef 4:31-32 (ARC)",
    verse_text: "Antes, sede uns para com os outros benignos, misericordiosos, perdoando-vos uns aos outros, como também Deus vos perdoou em Cristo.",
    focus: "O perdão liberta quem perdoa",
    reflection: "Muitas feridas internas têm raiz na falta de perdão. Cristo perdoou primeiro para que pudéssemos perdoar. Guardar mágoa é adoecer por dentro; perdoar é abrir espaço para o Espírito Santo curar.",
    prayer_direction: "Clame ao Senhor pela graça de perdoar quem te feriu. Interceda também pela pessoa que causou a ferida, entregando o julgamento à soberania de Deus.",
    challenge: "Nomeie diante de Deus alguém que você precisa perdoar e declare em oração que escolhe perdoar pela graça de Cristo.",
  },
  {
    day: 4,
    title: "Intercessão pelos enfermos",
    verse_ref: "Tg 5:14-16 (ARC)",
    verse_text: "Está alguém entre vós doente? Chame os presbíteros da igreja, e orem sobre ele... Confessai as vossas culpas uns aos outros e orai uns pelos outros, para que sareis; a oração feita por um justo pode muito em seus efeitos.",
    focus: "A oração eficaz do justo pode muito",
    reflection: "A Escritura nos convida a orar uns pelos outros. A intercessão é ato de amor e fé, e Deus responde segundo Sua vontade soberana. Combinamos oração com apoio pastoral, comunhão da igreja e acompanhamento médico responsável.",
    prayer_direction: "Interceda pelos enfermos que você conhece. Apresente cada nome a Deus com fé e confiança na soberania Dele, submetendo cada caso à vontade do Pai.",
    challenge: "Faça uma lista de pessoas enfermas e ore por cada uma pelo nome, entregando cada caso à graça de Deus.",
  },
  {
    day: 5,
    title: "Fé e perseverança durante o processo",
    verse_ref: "Rm 12:12 (ARC)",
    verse_text: "Alegrai-vos na esperança, sede pacientes na tribulação, perseverai na oração.",
    focus: "Persevere na oração",
    reflection: "Nem sempre a cura é imediata. A fé bíblica persevera mesmo quando não vê ainda a resposta. Deus age no tempo Dele, e nossa espera é santa quando ancorada em Cristo.",
    prayer_direction: "Clame ao Senhor pela fé que sustenta durante o processo. Ore pela perseverança de quem aguarda a cura com esperança, sabendo que a paciência é fruto do Espírito.",
    challenge: "Ore hoje por alguém que está no processo de espera. Encoraje-o com uma mensagem de fé e esperança.",
  },
  {
    day: 6,
    title: "Cura e reconciliação da família",
    verse_ref: "Cl 3:12-14 (ARC)",
    verse_text: "Revesti-vos, pois, como eleitos de Deus, santos e amados, de entranhas de misericórdia, de benignidade, humildade, mansidão, longanimidade... E, sobre tudo isto, revesti-vos de amor, que é o vínculo da perfeição.",
    focus: "O amor é o vínculo da perfeição",
    reflection: "Famílias também precisam de cura. Relacionamentos feridos, distâncias emocionais e mágoas antigas podem ser restaurados pela graça de Deus. O lar é o primeiro lugar onde o Evangelho se torna visível.",
    prayer_direction: "Interceda pela cura dos relacionamentos familiares. Apresente a Deus os conflitos e peça a reconciliação que só Ele pode dar.",
    challenge: "Entre em contato hoje com um familiar com quem a relação precisa ser restaurada. Dê o primeiro passo.",
  },
  {
    day: 7,
    title: "Gratidão, testemunho e esperança",
    verse_ref: "Sl 103:1-5 (ARC)",
    verse_text: "Bendize, ó minha alma, ao Senhor, e tudo o que há em mim bendiga o seu santo nome... o qual sara todas as tuas enfermidades.",
    focus: "Bendize, ó minha alma, ao Senhor",
    reflection: "Ao final desta semana, lembramos que Deus é bom. Mesmo quando a cura física ainda não chegou, há razões para agradecer e continuar esperando. A gratidão fortalece a alma e testifica da fidelidade do Senhor.",
    prayer_direction: "Agradeça a Deus por cada sinal de cura recebido nesta semana. Confie que Ele continua agindo mesmo no silêncio, segundo a Sua perfeita vontade.",
    challenge: "Compartilhe com alguém como esta semana de oração por cura impactou sua vida. Seja testemunho vivo da graça de Deus.",
  },
];

// Descrição pastoral de cada tema (usada no card quando o override for ativado
// e a landing não tiver enviado description alinhada).
const THEME_META = {
  cura: {
    title: "Semana da Cura",
    description: "Sete dias clamando pela cura interior, emocional, relacional e física. Um convite para trazer diante de Deus as feridas mais profundas e receber, pela graça, a restauração que só Cristo oferece.",
    days: CURA_DAYS,
  },
};

/**
 * Retorna o pacote interno de 7 dias para o theme_slug, ou null se não houver.
 */
export function getInternalThemeContent(themeSlug) {
  if (!themeSlug || typeof themeSlug !== "string") return null;
  return THEME_META[themeSlug.toLowerCase()] || null;
}

/**
 * Detecta se o conteúdo dos dias vindo da landing está alinhado com o
 * theme_slug ativo. Heurística: procura o nome do tema ou palavras-chave
 * do tema no conjunto de títulos + focos dos dias.
 *
 * Retorna:
 *   - true   → dias alinhados ao tema (usar landing como está)
 *   - false  → mismatch detectado (ativar override interno se disponível)
 *   - null   → sem informação suficiente para decidir (usar landing)
 */
export function isLandingContentAlignedWithTheme(themeSlug, landingDays) {
  if (!themeSlug || !Array.isArray(landingDays) || landingDays.length === 0) {
    return null;
  }
  const slug = themeSlug.toLowerCase();
  // Palavras-chave que devem aparecer nos títulos/foco dos dias quando o tema
  // está correto. Se nenhuma aparece, é mismatch.
  const KEYWORDS = {
    cura: ["cura", "sarar", "sarado", "restauração", "enferm", "quebrantad", "ferida"],
    familia: ["família", "familia", "lar", "casa", "esposa", "esposo", "filhos", "pais"],
    esperanca: ["esperança", "esperanca", "promessa", "confiança"],
    perdao: ["perdão", "perdao", "reconciliação", "misericórdia", "graça"],
    paz: ["paz", "descanso", "sossego", "aquiet"],
    proposito: ["propósito", "chamado", "vocação", "missão", "enviado"],
    gratidao: ["gratidão", "gratidao", "louvor", "bendize", "agradec"],
    identidade: ["identidade", "filho de deus", "herdeiro", "imagem"],
    oracao: ["oração", "oracao", "orar", "clamor", "intercessão"],
  };
  const words = KEYWORDS[slug];
  if (!words) return null; // slug desconhecido, deixa landing decidir
  const haystack = landingDays
    .slice(0, 7)
    .map((d) => `${d?.title || ""} ${d?.focus || d?.theme || ""}`.toLowerCase())
    .join(" ");
  const hits = words.filter((w) => haystack.includes(w)).length;
  // Se pelo menos 2 dias contêm palavra-chave do tema → alinhado.
  return hits >= 2;
}
